// Serviço para gerenciar notificações do browser/SO
class BrowserNotificationService {
  private permission: NotificationPermission = 'default'

  constructor() {
    if ('Notification' in window) {
      this.permission = Notification.permission
    }
  }

  // Solicita permissão para notificações
  async requestPermission(): Promise<NotificationPermission> {
    if (!('Notification' in window)) {
      console.warn('Este browser não suporta notificações')
      return 'denied'
    }

    if (this.permission === 'granted') {
      return 'granted'
    }

    const permission = await Notification.requestPermission()
    this.permission = permission
    return permission
  }

  // Verifica se notificações estão habilitadas
  isEnabled(): boolean {
    return this.permission === 'granted'
  }

  // Exibe notificação do sistema
  show(title: string, options?: NotificationOptions): Notification | null {
    if (!this.isEnabled()) {
      console.warn('Permissão de notificação não concedida')
      return null
    }

    try {
      const notification = new Notification(title, {
        icon: '/icon-192x192.png', // Ícone da notificação
        badge: '/icon-192x192.png',
        tag: 'order-system', // Agrupa notificações
        requireInteraction: false, // Não requer interação para fechar
        ...options,
      })

      // Auto-fechar após 5 segundos
      setTimeout(() => {
        notification.close()
      }, 5000)

      return notification
    } catch (error) {
      console.error('Erro ao exibir notificação:', error)
      return null
    }
  }

  // Notificação de novo pedido
  notifyNewOrder(orderNumber: string, clientName: string): void {
    this.show('Novo Pedido Criado! 🎉', {
      body: `Pedido ${orderNumber} criado para ${clientName}`,
      icon: '/icon-192x192.png',
      tag: 'new-order',
    })
  }

  // Notificação de status alterado
  notifyStatusChange(orderNumber: string, status: string): void {
    const statusMessages: Record<string, string> = {
      pendente: '⏳ Pedido está pendente',
      processando: '🔄 Pedido está sendo processado',
      concluido: '✅ Pedido foi concluído',
      cancelado: '❌ Pedido foi cancelado',
    }

    this.show(`Status Atualizado - ${orderNumber}`, {
      body: statusMessages[status] || `Status alterado para ${status}`,
      icon: '/icon-192x192.png',
      tag: 'status-change',
    })
  }

  // Notificação genérica
  notify(title: string, message: string, type: 'info' | 'success' | 'warning' | 'error' = 'info'): void {
    const icons: Record<string, string> = {
      info: 'ℹ️',
      success: '✅',
      warning: '⚠️',
      error: '❌',
    }

    this.show(`${icons[type]} ${title}`, {
      body: message,
      icon: '/icon-192x192.png',
      tag: type,
    })
  }
}

export const browserNotificationService = new BrowserNotificationService()
